module.exports = __webpack_public_path__ + "media/images/email/email_free-f13e2ab0331c921a8b8b6347912a3cf9.svg";